import { jsx as _jsx } from "react/jsx-runtime";
import CheckboxChecked from '@assets/icons/checkbox-checked.svg';
const CustomChecboxCheckedIcon = () => {
    return (_jsx("img", { src: CheckboxChecked, alt: "custom-checkbox-checked-icon" }));
};
export default CustomChecboxCheckedIcon;
